module.exports = __webpack_public_path__ + "img/freelancer.57585e6e.svg";